import PropTypes from 'prop-types';

export const TPagination = PropTypes.shape({
  current_page: PropTypes.number.isRequired,
  from: PropTypes.number.isRequired,
  last_page: PropTypes.number.isRequired,
  per_page: PropTypes.number.isRequired,
  to: PropTypes.number.isRequired1,
  total: PropTypes.number.isRequired,
});
